<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <h6>Logs / Trazabilidad</h6>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <!-- Filtros -->
            <div class="px-3 mb-3 row g-2">
              <div class="col-12 col-md-4">
                <input
                  v-model="pagination.search"
                  @input="manualSearch"
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Buscar..."
                />
              </div>
              <div class="col-12 col-md-3">
                <select
                  v-model="pagination.action"
                  @change="filterChanged"
                  class="form-select form-select-sm"
                >
                  <option value="">Todas</option>
                  <option value="LEAD_CREATED">Lead creado</option>
                  <option value="AGENT_CREATED">Agente creado</option>
                  <option value="IP_ASSIGNED">IP asignada</option>
                  <option value="IP_UPDATED">IP actualizada</option>
                  <option value="IP_ASSIGNED_BULK">IP masiva al staff</option>
                  <option value="LEAD_DELETED">Lead borrado</option>
                </select>
              </div>
              <div class="col-6 col-md-2">
                <input
                  v-model="pagination.from"
                  @change="filterChanged"
                  type="date"
                  class="form-control form-control-sm"
                  placeholder="Desde"
                />
              </div>
              <div class="col-6 col-md-2">
                <input
                  v-model="pagination.to"
                  @change="filterChanged"
                  type="date"
                  class="form-control form-control-sm"
                  placeholder="Hasta"
                />
              </div>
            </div>

            <div v-if="loading" class="text-center py-4">Cargando...</div>

            <div v-else class="table-responsive">
              <table class="table table-bordered table-sm align-middle">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha y hora</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Acción</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Realizado por</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Afectado</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Detalle</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(log, index) in arrayLogs" :key="index">
                    <td>{{ $filters.formatDateTime(log.createdAt) }}</td>
                    <td>
                      <span class="badge badge-sm bg-gradient-info">{{ actionLabel(log.action) }}</span>
                    </td>
                    <td>
                      {{ log.performed_by_name }}<br />
                      <small class="text-muted">{{ log.performed_by_email }}</small>
                    </td>
                    <td>{{ log.target_name || '—' }}</td>
                    <td>{{ formatDetails(log.details) }}</td>
                  </tr>
                  <tr v-if="!arrayLogs.length && !loading">
                    <td colspan="5" class="text-center py-3">Sin registros</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="px-3 d-flex justify-content-between align-items-center">
              <small>Filas totales: {{ pagination.totalRows }}</small>
              <v-pagination
                v-model="pagination.page"
                :pages="pagination.pages"
                :range-size="1"
                active-color="#DCEDFF"
                @update:modelValue="reloadPaginate"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from "@/utils/httpRequest";

export default {
  name: "audit-logs",
  data() {
    return {
      arrayLogs: [],
      loading: false,
      pagination: {
        searchTimer: null,
        page: 1,
        pages: 0,
        limit: 10,
        search: '',
        totalRows: 0,
        action: '',
        from: '',
        to: ''
      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      try {
        const { data } = await get(
          `audit?page=${this.pagination.page}&limit=${this.pagination.limit}&search=${encodeURIComponent(this.pagination.search)}&action=${this.pagination.action || ''}&from=${this.pagination.from || ''}&to=${this.pagination.to || ''}`,
          null,
          true
        );
        this.arrayLogs = data.docs;
        this.pagination.totalRows = data.count;
        this.pagination.page = data.page;
        this.pagination.pages = data.pages;
      } finally {
        this.loading = false;
      }
    },
    reloadPaginate(page) {
      this.pagination.page = page;
      this.getData();
    },
    manualSearch() {
      clearTimeout(this.pagination.searchTimer);
      this.pagination.searchTimer = setTimeout(() => {
        this.pagination.page = 1;
        this.getData();
      }, 400);
    },
    filterChanged() {
      this.pagination.page = 1;
      this.getData();
    },
    actionLabel(action) {
      const map = {
        LEAD_CREATED: "Lead creado",
        AGENT_CREATED: "Agente creado",
        IP_ASSIGNED: "IP asignada",
        IP_UPDATED: "IP actualizada",
        IP_ASSIGNED_BULK: "IP masiva al staff",
        LEAD_DELETED: "Lead borrado"
      };
      return map[action] || action;
    },
    formatDetails(details) {
      if (!details || (typeof details === 'object' && Object.keys(details).length === 0)) {
        return "—";
      }
      return JSON.stringify(details);
    }
  }
};
</script>
